import {FC} from "react";
import {IHelp} from "modules/reducers";
import {SectionContent, SectionTitle, SectionWrapper} from "./common";
import styled from "styled-components";

const Wrapper = styled(SectionWrapper)`
	padding: 20px;
`;

export const HelpText: FC<IHelp> = ({text, title, type}) => {
	return (
		<Wrapper>
			<SectionTitle>{title}</SectionTitle>
			<SectionContent dangerouslySetInnerHTML={{__html: text}} />
		</Wrapper>
	);
};
